// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================= */
/*              GLOBAL STYLES                */
/* ========================================= */
.deposit-fiat-wrapper {
  font-family: "Inter", sans-serif;
  color: #eaecef;
  background: transparent;
  line-height: 1.5;
  width: 100%;
}

/* ========================================= */
/*               HERO SECTION                */
/* ========================================= */
.df-hero-section {
  background-position: top right;
  background-repeat: no-repeat;
  background-size: 580px;
  padding: 72px 0 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 0;
}

.dashboard_right.fiatmobile {
  padding-right: 0px;
}

.dashboard_right.fiatmobile .df-hero-container {
  padding-right: 60px;
}

body.light_theme .deposit-fiat-wrapper .df-hero-section {
  background-image: none !important;
}

.df-hero-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 48px;
}

.df-hero-content {
  flex: 1 1;
  max-width: 800px;
  min-width: 0;
}

.df-gateway-tag {
  color: #d1aa67;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.df-gateway-tag::after {
  content: "";
  height: 1px;
  width: 40px;
  background: #eaeaea;
}

.df-hero-content h1 {
  font-size: 60px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #eaecef;
  line-height: 1.1;
}

.df-hero-content h1 span {
  color: #d1aa67;
}

.df-hero-content>p {
  font-size: 19px;
  color: #94A3B8;
  line-height: 1.6;
  margin: 16px 0 24px;
}

.df-features-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  padding: 5px 0px 10px;
}

.df-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.df-feature-icon {
  width: 60px;
  height: 60px;
  min-width: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.df-feature-icon img {
  width: 100%;
}

.df-feature-text h4 {
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 5px;
}

.df-feature-text p {
  font-size: 14px;
  color: #94A3B8;
  margin: 0;
  line-height: 1.45;
}

.df-hero-widget {
  width: 580px;
  flex-shrink: 0;
  max-width: 100%;
  background: rgb(255 255 255 / 5%);
  border-radius: 30px;
  box-shadow: 0 0px 20px rgba(0, 0, 0, 0.07);
  padding: 32px;
  border: 1px solid #656565;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
}

.df-widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.df-widget-header h3 {
  font-size: 25px;
  font-weight: 700;
  position: relative;
  color: #fff;
}

/* 
.df-widget-header h3::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0px;
  margin: 0 auto;
  width: 16px;
  height: 3px;
  background: #eaecef;
  border-radius: 2px;
} */

.df-withdrawal-btn {
  background: #D1AA67;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 20px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
}

.df-withdrawal-btn:hover {
  color: #fff;
  opacity: 0.8;
}

.df-input-group {
  margin-bottom: 25px;
}

.df-input-label {
  font-size: 14px;
  font-weight: 500;
  color: #9CA3AF;
  margin-bottom: 7px;
  display: block;
}

.df-input-box {
  background: rgb(255 255 255 / 5%);
  border: 1px solid #5c5c5c;
  border-radius: 50px;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.df-input-box input {
  background: transparent;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  width: 100%;
  outline: none;
}

.df-currency-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 15px;
  color: #D1D5DB;
  cursor: pointer;
}

.df-currency-icon {
  width: 24px;
  height: 24px;
  background: #26a17b;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.df-payment-method {
  flex-direction: column;
  /* border: 2px solid #d1aa67; */
  border-radius: 10px;
  padding: 20px;
  display: flex;
  gap: 12px;
  margin-bottom: 25px;
  background: rgb(255 255 255 / 5%);
}

.df-method-icon {
  width: 44px;
  min-width: 44px;
  height: 44px;
  background: rgb(209 170 103 / 10%);
  border: 1px solid rgb(209 170 103 / 20%);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.df-method-icon img {
  width: 22px;
}

.df-method-details {
  flex: 1 1;
}

.df-method-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.checkiconbnk {
  width: 20px;
  height: 20px;
  background: #D1AA67;
  border-radius: 50px;
  min-width: 20px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}

.df-input-box img {
  width: 24px;
  margin-right: 7px;
}

.df-method-title {
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
}

.df-recommended-tag {
  background: rgb(209 170 103 / 20%);
  border: 1px solid rgb(209 170 103 / 30%);
  color: #D1AA67;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 50px;
  font-weight: 600;
}

.df-check-icon {
  color: #d1aa67;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.df-method-fee {
  font-size: 14px;
  color: #9CA3AF;
  margin-bottom: 4px;
}

.df-method-desc {
  font-size: 14px;
  color: #9CA3AF;
}

.paybl_methoddl {
  display: flex;
  width: 100%;
  gap: 12px;
}

.kyc_complete {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

.kyc_complete a {
  color: #D1AA67;
  text-decoration: underline;
}

.df-submit-btn {
  background: #D1AA67;
  color: #fff;
  width: 100%;
  padding: 15px;
  text-align: center;
  border-radius: 50px;
  margin-top: 24px;
  font-size: 17px;
  min-height: 56px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}

.df-submit-btn:hover {
  opacity: 0.95;
  color: #fff;
}

body.light_theme .df-payment-method.beneficiarynote p {
  color: #454545;
}

.df-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.df-alert {
  padding: 12px 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  font-size: 14px;
}

.df-alert--error {
  background: rgba(248, 113, 113, 0.12);
  border: 1px solid rgba(248, 113, 113, 0.35);
  color: #fca5a5;
}

.df-alert--info {
  background: rgba(209, 170, 103, 0.1);
  border: 1px solid rgba(209, 170, 103, 0.35);
  color: #d1aa67;
}

/* ========================================= */
/*          VIRTUAL ACCOUNT CARD             */
/* ========================================= */
.df-va-card {
  display: flex;
  flex-direction: column;
}

.df-va-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
}

.df-va-kicker {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #848e9c;
  margin-bottom: 10px;
}

/* .df-hero-content h1 br {
  display: none;
} */

.df-va-status-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.df-va-status {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid rgb(16 185 129 / 30%);
  font-size: 10px;
  font-weight: 600;
  background: rgb(16 185 129 / 10%);
  color: #34D399;
}

.df-va-status--pending {
  background: rgba(209, 170, 103, 0.15);
  color: #d1aa67;
}

.df-va-currency {
  font-size: 13px;
  font-weight: 500;
  color: #848e9c;
}

.df-va-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
}

.df-va-label {
  font-size: 15px;
  color: #9CA3AF;
  flex-shrink: 0;
  white-space: nowrap;
}

.df-va-value {
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  text-align: right;
  word-break: normal;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.df-va-value--iban {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
  white-space: nowrap;
}

.df-va-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.df-va-num-text {
  white-space: nowrap;
  letter-spacing: 0.5px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.df-va-copy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0px;
  padding: 0px 2px;
  border: none;
  background: transparent;
  color: #9CA3AF;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 0.15s ease, color 0.15s ease;
}

/* .df-va-copy:hover {
  background: rgba(209, 170, 103, 0.12);
} */

.df-va-copy i {
  font-size: 16px;
  line-height: 1;
}

.df-va-iban-missing {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #d1aa67;
}

.df-guide-card {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 0;
  border-radius: 22px 22px 0px 0px;
  padding: 34px;
  border: 1px solid #23262C;
  border-bottom: none;
  background: linear-gradient(180deg, rgba(30, 33, 39, 1) 0%, rgba(23, 26, 32, 1) 100%);
  overflow: hidden;
  text-align: left;
}

.df-guide-block+.df-guide-block {
  margin-top: 32px;
}

.df-guide-block__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 700;
  /* letter-spacing: 0.06em; */
  /* text-transform: uppercase; */
  color: #fff;
}

.df-guide-block__icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(209, 170, 103, 0.12);
  color: #d1aa67;
}

.df-fee-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px;
  margin-bottom: 14px;
}

.df-fee-stat {
  padding: 20px;
  border-radius: 16px;
  background: rgb(255 255 255 / 3%);
}

.df-fee-stat span {
  display: block;
  font-size: 15px;
  color: #94A3B8;
  margin-bottom: 6px;
}

.df-fee-stat strong {
  display: block;
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
}

.df-fee-stat__ok {
  color: #22c55e;
}

.df-guide-note {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: #94A3B8;
  display: flex;
  align-items: center;
  gap: 8px;
}

.df-how-steps {
  margin: 0px;
  padding: 5px 0px 0px;
  list-style: none;
  counter-reset: df-how;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.df-how-steps li {
  counter-increment: df-how;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  font-size: 17px;
  line-height: 1.5;
  color: #CBD5E1;
}

.df-how-steps li::before {
  content: counter(df-how);
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(23, 26, 32, 0) 100%);
}

.df-how-steps li>span {
  flex: 1 1;
  min-width: 0;
}

.dividerbdr {
  max-width: 730px;
  height: 1.40px;
  background: linear-gradient(356deg, rgb(23 26 32) 0%, rgb(129 129 129) 50%, rgb(25 27 34) 100%);
  margin: 28px 0px;
}

.df-how-steps strong {
  color: #ffffff;
  font-weight: 400;
}

.df-va-row--iban {
  /* padding: 12px 12px; */
  /* margin: 4px -12px 0; */
  /* border-radius: 10px; */
  /* border-bottom: none; */
  /* background: rgba(209, 170, 103, 0.08); 
    /* border: 1px solid rgba(209, 170, 103, 0.22);*/

  width: 100%;
}

.df-payment-method.beneficiarynote {
  flex-direction: row;
  margin-top: 32px;
  border-radius: 16px;
}


.df-payment-method.beneficiarynote p {
  font-size: 13px;
  color: #D1D5DB;
}

.df-va-instructions {
  margin-top: 8px;
  padding: 16px;
  border-radius: 12px;
  border: 1px dashed rgba(209, 170, 103, 0.45);
  background: rgba(209, 170, 103, 0.06);
  font-size: 13px;
  line-height: 1.6;
  color: #848e9c;
}

.df-va-instructions strong {
  color: #d1aa67;
}

.df-fee-notice {
  margin: 0 0 16px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(209, 170, 103, 0.35);
  background: rgba(209, 170, 103, 0.08);
  font-size: 13px;
  line-height: 1.55;
  color: #848e9c;
}

.df-fee-notice p {
  margin: 0 0 8px;
}

.df-fee-notice p:last-child {
  margin-bottom: 0;
}

.df-va-card .df-limit-list,
.df-hero-widget .df-limit-list {
  margin-top: 16px;
  margin-bottom: 0;
}

.df-va-card .df-input-group {
  margin-bottom: 16px;
}

.df-va-card .df-submit-btn {
  margin-top: 4px;
  margin-bottom: 16px;
}

.df-va-beneficiary-note {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(209, 170, 103, 0.55);
  background: rgba(209, 170, 103, 0.08);
}

.df-va-beneficiary-note__icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(107, 87, 53, 1) 100%);
  color: #1a1408;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.df-va-beneficiary-note p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #eaecef;
}

.df-va-add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 14px;
  padding: 14px 16px;
  border: none;
  border-radius: 30px;
  background: #d1aa67;
  color: #1a1408;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.df-va-add-btn:hover {
  color: #1a1408;
  opacity: 0.9;
}

.df-intent-max {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #d1aa67;
  background: transparent;
  color: #d1aa67;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.df-intent-max:hover:not(:disabled) {
  background: rgba(209, 170, 103, 0.12);
}

.df-intent-max:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.df-intent-box {
  margin: 0 0 16px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(209, 170, 103, 0.45);
  background: rgba(209, 170, 103, 0.08);
  color: #eaecef;
}

.df-intent-box strong {
  display: block;
  margin-bottom: 6px;
  color: #d1aa67;
  font-size: 15px;
}

.df-intent-box p {
  margin: 0 0 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #848e9c;
}

.df-intent-box p:last-child {
  margin-bottom: 0;
}

.df-intent-open {
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.df-intent-open li {
  margin: 0 0 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #2b3139;
  font-size: 13px;
  line-height: 1.45;
  color: #eaecef;
}

.df-intent-open li:last-child {
  margin-bottom: 0;
}

/* ========================================= */
/*               KYC MODAL                   */
/* ========================================= */
.df-kyc-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.62);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.df-kyc-modal {
  width: 560px;
  max-width: 100%;
  position: relative;
  text-align: center;
  padding: 28px 24px 24px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #181a20;
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.5);
}

.df-kyc-modal-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #8e939c;
  font-size: 22px;
  cursor: pointer;
}

.df-kyc-modal-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.df-kyc-modal-art {
  margin: 8px auto 12px;
  max-width: 180px;
}

.df-kyc-modal-art img {
  width: 100%;
  height: auto;
  display: block;
}

.df-kyc-modal-title {
  margin: 12px 0 10px;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}

.df-kyc-modal-text {
  margin: 0 0 22px;
  font-size: 14px;
  line-height: 1.55;
  color: #84888c;
}

.df-kyc-modal-actions {
  display: flex;
  justify-content: center;
}

.df-kyc-modal-confirm {
  min-width: 220px;
  height: 46px;
  border: none;
  border-radius: 999px;
  background: #d1aa67;
  color: #0c0d10;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.df-kyc-modal-confirm:hover {
  background: #c49a55;
}

/* ========================================= */
/*               WHY DEPOSIT                 */
/* ========================================= */
.df-why-section {
  padding: 80px 0px;
  text-align: center;
}

body.light_theme .depositcrypto_lft .deposit_history_row {
  border-top: 1px solid #dadada;
}

.df-section-title {
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 0.4px;
  margin-bottom: 50px;
  color: #eaecef;
  position: relative;
  z-index: 999;
}

/* .df-section-title span {
  color: #d1aa67;
} */

.df-why-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 85px;
  margin-top: 110px;
}

.df-why-card {
  width: 280px;
  background: #171a20;
  /* box-shadow: 0px 0px 10px #00000010; */
  border: 4px solid rgb(255 255 255 / 18%);
  border-radius: 32px;
  position: relative;
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: left;
  transition: 0.3s;
}

.df-why-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.df-why-card::before {
  position: absolute;
  content: "";
  right: -10px;
  top: -30px;
  height: 90%;
  width: 85%;
  background: #171a20;
}

img.afterarrow {
  width: 68px;
  position: absolute;
  bottom: 37px;
  right: -68px;
}

.df-why-card:last-child img.afterarrow {
  display: none;
}

.df-why-icon {
  width: 70px;
  height: 70px;
  min-width: 70px;
  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(107, 87, 53, 1) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
}

.df-why-icon img {
  width: 32px;
}

.df-why-card h4 {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #fff;
  min-width: 160px;
}

.df-why-card p {
  font-size: 17px;
  color: #fff;
  line-height: 1.6;
  position: relative;
  z-index: 999;
}

.tophd_how {
  gap: 15px;
  position: relative;
  margin-top: -67px;
  margin-left: 20px;
  margin-bottom: 36px;
}

.tophd_how h4 {
  margin-bottom: 0px;
}

/* ========================================= */
/*               POPULAR PAIRS               */
/* ========================================= */
.df-pairs-section {
  padding: 40px 0 80px 0;
}

.df-pairs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.df-pairs-header h3 {
  color: #eaecef;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}

.df-deposit-link {
  color: #d1aa67;
  font-size: 16px;
  font-weight: 600;
  text-decoration: underline;
}

.df-deposit-link:hover {
  color: #d1aa67;
  opacity: 0.8;
}

.df-pairs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.df-pair-card {
  border: 1px solid #2b3139;
  border-radius: 14px;
  padding: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 0.2s;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
}

.df-pair-card:hover {
  border-color: #d1aa67;
}

.df-pair-info {
  display: flex;
  flex-direction: column;
}

.df-pair-name {
  font-size: 20px;
  font-weight: 600;
  color: #848e9c;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.df-pair-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.df-pair-icon.usdt {
  background: #26a17b;
}

.df-pair-icon.btc {
  background: #f7931a;
}

.df-pair-icon.eth {
  background: #627eea;
}

.df-pair-price {
  color: #eaecef;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.df-pair-change {
  font-size: 14px;
  font-weight: 600;
}

.df-pair-change.positive {
  color: #22c55e;
}

.df-pair-change.negative {
  color: #ef4444;
}

.df-pair-chart svg {
  width: 90px;
  height: 60px;
}

.df-pair-chart.positive svg {
  color: #26a17b;
}

.df-pair-chart.negative svg {
  color: #e25b4d;
}

/* ========================================= */
/*               BANNER SECTION              */
/* ========================================= */
.df-banner-section {
  margin-bottom: 100px;
  background: #1e2329;
  border-radius: 16px;
  padding: 30px 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.df-banner-content h2 {
  font-size: 44px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #eaecef;
}

.df-banner-content p {
  font-size: 18px;
  color: #848e9c;
}

.df-banner-img {
  height: 240px;
  margin-right: 40px;
  padding-top: 10px;
}

/* ========================================= */
/*                  FAQ SECTION              */
/* ========================================= */
.df-faq-section {
  margin-bottom: 100px;
}

.df-faq-section h2 {
  font-size: 40px;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 40px;
}

.df-faq-item {
  border-bottom: 1px solid #eaeaea2e;
}

body.light_theme .df-faq-item {
  border-bottom: 1px solid #eaeaea;
}

.df-faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  color: #eaecef;
  padding: 24px 0;
}

.df-faq-answer {
  padding-bottom: 24px;
  font-size: 15px;
  color: #848e9c;
  line-height: 1.6;
}

/* ========================================= */
/*          DEPOSIT FIAT HISTORY             */
/* ========================================= */
.df-deposit-history-section {
  padding: 0 0 80px;
  overflow: visible;
}

.df-deposit-history-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.df-deposit-history-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  letter-spacing: -0.02em;
}

.df-deposit-history-filters {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.df-dd {
  position: relative;
  min-width: 140px;
}

.df-dd-label {
  display: block;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #848e9c;
  letter-spacing: 0.02em;
}

.df-dd-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #2b3139;
  background: #181a20;
  color: #eaecef;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.df-dd-trigger:hover,
.df-dd-trigger.is-open {
  border-color: #3a414b;
}

.df-dd-trigger:focus-visible {
  outline: none;
  border-color: #d1aa67;
}

.df-dd-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.df-dd-chevron {
  flex-shrink: 0;
  color: #848e9c;
  transition: transform 0.15s ease;
}

.df-dd.is-open .df-dd-chevron {
  transform: rotate(180deg);
}

.df-dd-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 30;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  border-radius: 8px;
  border: 1px solid #2b3139;
  background: #1e2329;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
  overflow: hidden;
}

.df-dd-option {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: #eaecef;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.df-dd-option:hover,
.df-dd-option.is-selected {
  background: rgba(209, 170, 103, 0.16);
  color: #d1aa67;
}

.df-deposit-history-export-btn {
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #d1aa67;
  background: transparent;
  color: #d1aa67;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    color 0.15s ease;
}

.df-deposit-history-export-btn:hover:not(:disabled) {
  background: #d1aa67;
  color: #181a20;
}

.df-deposit-history-export-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.df-deposit-history-card {
  overflow: visible;
}

.df-deposit-history-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  min-width: 0;
}

.df-deposit-history-status {
  margin: 0;
  padding: 16px 4px;
  font-size: 13px;
  color: #848e9c;
}

.df-deposit-history-status p {
  margin: 0 0 12px;
}

.df-deposit-history-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 72px 16px 88px;
  text-align: center;
}

.df-deposit-history-empty-img {
  width: 120px;
  height: auto;
  max-width: 100%;
  opacity: 0.9;
  filter: invert(1);
}

.df-deposit-history-head-wrap {
  overflow: visible;
}

.df-deposit-history-head,
.df-deposit-history-row {
  display: grid;
  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;
  gap: 8px;
  align-items: center;
  min-width: 1240px;
}

.df-deposit-history-desktop--fiat .df-deposit-history-head,
.df-deposit-history-desktop--fiat .df-deposit-history-row {
  grid-template-columns: 1.2fr 1fr 0.9fr 0.7fr 1.5fr;
  min-width: 0;
}

.df-deposit-history-reason {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #84888c;
  white-space: normal;
  line-height: 1.35;
}

.df-deposit-history-more {
  display: flex;
  justify-content: center;
  padding: 16px 0 8px;
}

.df-deposit-history-empty-copy {
  margin: 8px 0 0;
  color: #84888c;
  font-size: 14px;
  text-align: center;
}

.df-fiat-deposit-detail-list {
  display: grid;
  gap: 14px;
  margin: 12px 0 0;
}

.withdraw_hist_detail_modal.wf-fiat-detail-modal {
  max-height: none;
  overflow: visible;
  padding: 18px 22px 16px;
  width: 520px;
}

.wf-fiat-detail-modal .withdraw_hist_stepper {
  margin-top: 12px;
}

body.light_theme .df-kyc-modal-overlay {
  background: rgb(255 255 255 / 62%);
}

.wf-fiat-detail-modal .withdraw_hist_step_note {
  margin-top: 2px;
  margin-bottom: 0;
}

.wf-fiat-detail-modal .withdraw_hist_rows {
  margin-top: 12px;
  padding-top: 10px;
  gap: 8px;
}

.wf-fiat-detail-modal .withdraw_hist_row {
  padding: 0;
  min-height: 0;
}

.wf-fiat-detail-modal .withdraw_hist_row_label,
.wf-fiat-detail-modal .withdraw_hist_row_value {
  font-size: 13px;
  line-height: 1.35;
}

.wf-fiat-detail-help {
  margin-top: 10px;
  padding-left: 0;
  text-align: center;
  align-items: center;
}

.df-fiat-deposit-detail-list>div {
  min-width: 0;
}

.df-fiat-deposit-detail-list dt {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 400;
  color: #84888c;
}

.df-fiat-deposit-detail-list dd {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #cecece;
}

.df-deposit-history-head {
  padding: 10px 0;
}

.df-deposit-history-head-cell {
  font-size: 13px;
  font-weight: 400;
  color: #84888c;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.df-deposit-history-body-wrap {
  min-width: 0;
}

.df-deposit-history-row {
  padding: 12px 0;
  border-top: 1px solid #2b3139;
  font-size: 13px;
  font-weight: 500;
  color: #cecece;
  line-height: 1.3;
  align-items: start;
  box-sizing: border-box;
  cursor: pointer;
}

.df-deposit-history-row-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.df-deposit-history-row-cell--action {
  text-transform: capitalize;
}

.df-deposit-history-desktop--fiat .df-deposit-history-row-cell--action {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  text-transform: none;
  white-space: normal;
  overflow: visible;
}

.df-deposit-history-trunc {
  display: inline-block;
  vertical-align: middle;
  max-width: calc(100% - 72px);
}

.df-deposit-history-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: #1f2937;
  color: #e2e8f0;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.05s ease;
  padding: 0;
  line-height: 1;
  text-decoration: none;
}

.df-deposit-history-copy-btn:hover {
  background: rgba(209, 170, 103, 0.18);
  border-color: rgba(209, 170, 103, 0.55);
  color: #d1aa67;
}

.df-deposit-history-copy-btn:active {
  transform: translateY(0.5px);
}

.df-deposit-history-copy-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(209, 170, 103, 0.25);
}

.df-deposit-history-action-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1;
}

.df-deposit-history-action-badge.is-success {
  background: #ecfdf31a;
  border-color: #a7f3d024;
  color: #0c935a;
}

.df-deposit-history-action-badge.is-pending {
  background: #fffbeb17;
  border-color: #fde68a1a;
  color: #cd7641;
}

.df-deposit-history-action-badge.is-danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b42318;
}

.df-deposit-history-action-badge.is-info {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.df-deposit-history-action-badge.is-neutral {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.22);
  color: #e2e8f0;
}

.df-deposit-history-mobile {
  display: none;
}

.df-deposit-history-mobile-card {
  padding: 16px 0;
  border-top: 1px solid #2b3139;
  cursor: pointer;
}

.df-deposit-history-mobile-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.df-deposit-history-mobile-date {
  font-size: 13px;
  font-weight: 600;
  color: #eaecef;
}

.df-deposit-history-mobile-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
}

.df-deposit-history-mobile-label {
  font-size: 13px;
  color: #848e9c;
}

.df-deposit-history-mobile-value {
  font-size: 13px;
  font-weight: 500;
  color: #eaecef;
  text-align: right;
}

.df-deposit-history-mobile-value--actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 72%;
}

@media (max-width: 991.98px) {
  .df-deposit-history-desktop {
    display: none !important;
  }

  .df-deposit-history-mobile {
    display: block !important;
  }

  .df-deposit-history-table-wrap {
    overflow-x: visible;
  }

  .df-deposit-history-top {
    align-items: flex-start;
  }
}

/* ========================================= */
/*               RESPONSIVE                  */
/* ========================================= */

@media (max-width: 1750px) {


  .df-why-card {
    width: 240px;
    padding: 20px;
  }

  .df-hero-content h1 {
    font-size: 52px;
  }

  .df-why-card p {
    font-size: 15px;
  }

  .df-why-card h4 {
    font-size: 20px;
  }

}


@media (max-width: 1550px) {

  .df-why-card {
    width: 200px;
    padding: 20px;
  }

  .df-why-card p {
    font-size: 15px;
  }

  .df-why-card h4 {
    font-size: 20px;
    min-width: 130px;
  }

  .df-why-icon {
    width: 54px;
    height: 54px;
    min-width: 54px;
  }

  img.afterarrow {
    right: -58px;
    width: 58px;
    bottom: 40px;
  }

  .df-why-grid {
    gap: 48px;
    margin-top: 100px;
  }

}

@media (max-width: 1440px) {
  .df-hero-content h1 {
    font-size: 44px;
  }

  .dashboard_right .container {
    max-width: 100%;
  }

  .df-hero-widget {
    width: 500px;
  }

  .df-hero-content>p {
    font-size: 17px;
  }

  .df-feature-icon {
    width: 42px;
    height: 42px;
    min-width: 42px;
  }

}

@media (max-width: 1376px) {
  .df-hero-content h1 {
    font-size: 36px;
  }

  .df-hero-widget {
    width: 420px;
  }

  .df-section-title {
    font-size: 32px;
    margin-bottom: 30px;
  }

}

@media (max-width: 1200px) {
  .container.df-hero-container {
    flex-direction: column;
  }

  .df-hero-section {
    padding: 30px 0px;
  }

  .df-hero-content h1 {
    font-size: 32px;
  }

  .dashboard_right.fiatmobile .df-hero-container {
    padding-right: 30px;
  }

  .df-hero-content>p {
    font-size: 16px;
    margin: 20px 0px 24px;
  }

  .df-hero-widget {
    width: 100%;
  }

  .df-why-section {
    padding: 40px 0px;
  }

  .df-why-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;
    margin-top: 80px;
    row-gap: 72px;
  }

  .tophd_how {
    margin-top: -49px;
    margin-bottom: 16px;
  }

  .df-why-card:last-child img.afterarrow {
    display: block;
  }

  img.afterarrow {
    right: -58px;
    width: 58px;
    bottom: 38px;
  }

  .df-section-title {
    font-size: 32px;
    margin-bottom: 30px;
  }

  .df-pairs-section {
    padding: 10px 0 40px 0;
  }

  .df-pairs-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .df-pairs-header h3 {
    color: #eaecef;
    font-size: 32px;
  }

  .df-banner-section {
    margin-bottom: 60px;
    padding: 20px 30px;
  }

  .df-banner-img {
    margin-right: 0px;
  }

  .df-banner-content h2 {
    font-size: 32px;
  }

  .df-faq-section h2 {
    font-size: 32px;
    margin-bottom: 20px;
  }
}

@media (max-width: 991px) {
  .dashboard_right.fiatmobile {
    padding: 0px;
  }

  .df-hero-content {
    width: 100%;
    max-width: 100%;
  }

  .df-hero-widget {
    width: 100%;
  }

  .df-hero-section {
    padding: 30px 0px 10px;
  }

  .df-gateway-tag {
    font-size: 15px;
  }

  .df-hero-content h1 {
    font-size: 28px;
  }

  .df-widget-header h3 {
    font-size: 22px;
    margin: 0px;
  }

  .df-submit-btn {
    padding: 13px;
    font-size: 15px;
    min-height: 100%;
  }

  img.afterarrow {
    bottom: 35px;
  }

  .df-why-card {
    width: 240px;
  }

  .df-hero-content>p {
    font-size: 15px;
    margin: 18px 0px 24px;
  }

  .df-why-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .df-pairs-grid {
    grid-template-columns: 1fr;
  }

  .df-banner-section {
    gap: 30px;
    padding: 40px 30px;
    margin-bottom: 50px;
  }

  .df-hero-container {
    gap: 30px;
  }

  .df-section-title {
    font-size: 26px;
  }

  .df-pairs-header h3 {
    color: #eaecef;
    font-size: 26px;
  }

  .df-banner-content h2 {
    font-size: 28px;
  }

  .df-faq-section h2 {
    font-size: 26px;
  }

  .df-why-section {
    padding: 40px 0px;
  }
}

@media (max-width: 767px) {

  section.df-deposit-history-section.depositfiathistory {
    padding-left: 20px;
    padding-right: 20px;
  }

  .df-va-card .df-limit-list,
  .df-hero-widget .df-limit-list {
    margin-bottom: 20px;
  }

  .df-hero-container {
    flex-direction: column;
    text-align: center;
  }

  .df-how-steps {
    flex-direction: row;
  }

  .df-how-steps li {
    flex-direction: column;
    width: 100%;
  }

  .df-why-grid {
    grid-template-columns: repeat(2, 1fr);
    margin-top: 60px;
  }

  .df-hero-content h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .df-gateway-tag {
    font-size: 14px;
    justify-content: center;
  }

  .df-feature-item {
    text-align: left;
  }

  .df-features-list {
    grid-template-columns: 1fr 1fr;
    gap: 18px;
  }

  .df-hero-content>p {
    margin: 10px 0px 15px;
  }

  .df-fee-stats {
    grid-template-columns: 1fr;
  }

  .df-feature-icon {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .df-feature-text h4 {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .df-feature-text p {
    font-size: 13px;
  }

  .df-hero-widget {
    width: 100%;
    padding: 24px;
    text-align: left;
  }

  .df-va-head {
    flex-direction: column;
  }

  .df-kyc-modal {
    padding: 24px 16px 20px;
  }

  .df-kyc-modal-title {
    font-size: 20px;
  }

  .df-kyc-modal-confirm {
    width: 100%;
    min-width: 0;
  }

  .df-submit-btn {
    width: 100%;
    padding: 10px;
    margin-top: 0px;
    font-size: 13px;
  }

  .df-payment-method {
    padding: 18px;
    margin-bottom: 20px;
  }

  .df-hero-section {
    padding: 30px 0px 10px;
  }

  .df-input-box input {
    font-size: 15px;
  }

  .df-banner-img {
    width: 200px;
    height: auto;
  }

  .df-why-section {
    padding: 30px 0px;
  }

  .df-section-title {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .df-deposit-history-title {
    font-size: 18px;
  }

  .df-dd {
    min-width: 120px;
  }

  .df-pairs-header h3 {
    color: #eaecef;
    font-size: 20px;
  }

  .df-deposit-link {
    font-size: 13px;
  }

  .df-pair-name {
    font-size: 16px;
  }

  .df-pair-price {
    color: #eaecef;
    font-size: 18px;
  }

  .df-pairs-section {
    padding: 40px 0 40px 0;
  }

  .df-banner-content h2 {
    font-size: 24px;
  }

  .df-banner-content p {
    font-size: 15px;
  }

  .df-guide-card {
    padding: 22px;
  }
}

@media (max-width: 580px) {

  .df-fee-stat strong {
    font-size: 18px;
  }

  .df-hero-content h1 {
    font-size: 22px;
  }

  .df-why-card p {
    font-size: 13px;
  }

  .df-fee-stat span {
    font-size: 13px;
  }

  .df-fee-stats {
    gap: 20px;
  }

  .df-guide-note {
    font-size: 14px;
  }

  .dividerbdr {
    margin: 18px 0px;
  }

  .df-widget-header h3 {
    font-size: 20px;
  }

  .df-withdrawal-btn {
    font-size: 13px;
  }

  .df-limit-list__title {
    font-size: 18px !important;
  }

  .df-banner-section {
    flex-direction: column;
    gap: 15px;
    text-align: center;
    padding: 28px;
    margin-bottom: 30px;
  }

  .df-how-steps li {
    font-size: 11px;
  }

  .df-va-value {
    font-size: 12px;
  }

  .df-limit-row {
    font-size: 12px;
  }

  .df-faq-section h2 {
    font-size: 24px;
    margin-bottom: 18px;
  }

  .df-feature-item {
    text-align: center;
    flex-direction: column;
  }

  .df-feature-icon {
    margin: 0 auto;
  }

  .df-faq-question {
    font-size: 15px;
    padding: 15px 0;
  }

  .df-faq-answer {
    padding-bottom: 18px;
    font-size: 14px;
  }

  .df-pairs-section {
    padding: 20px 0 40px 0;
  }

  .df-method-title {
    flex-direction: column;
    font-size: 16px;
    align-items: start;
    margin-bottom: 5px;
  }

  .df-section-title {
    font-size: 22px;
  }

  .df-why-grid {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 20px;
    row-gap: 24px;
  }

  .df-why-card::before {
    display: none;
  }

  .df-why-card {
    border: 2px solid rgb(255 255 255 / 18%);
  }

  .df-why-card:last-child img.afterarrow {
    display: none;
  }

  .df-why-icon {
    width: 40px;
    height: 40px;
    padding: 8px;
    min-width: 40px;
  }

  .df-why-card h4 {
    font-size: 18px;
  }

  .df-hero-content>p {
    font-size: 14px;
  }

  img.afterarrow {
    display: none;
  }

  .df-why-card {
    width: 100%;
  }

  .tophd_how {
    margin-top: 0px;
    margin-bottom: 12px;
    margin-left: 0px;
  }

  .df-why-card h4 {
    min-width: auto;
  }


}

/* ========================================= */
/*               LIGHT THEME                 */
/* ========================================= */
body.light_theme .deposit-fiat-wrapper {
  color: #1a1a1a;
  background: #ffffff;
}

body.light_theme .df-hero-content h1 {
  color: #1e2329;
}

body.light_theme .df-hero-content>p {
  color: #707a8a;
}

body.light_theme .df-feature-text h4 {
  color: #1a1a1a;
}

body.light_theme .df-feature-item {
  background: #fff;
  border-color: #eaecef;
}

body.light_theme .df-hero-widget {
  background: rgb(0 0 0 / 5%);
  border: 1px solid #f2f2f2;
  box-shadow: inset 0px 4px 20px #e5e5e5;
}

body.light_theme .df-widget-header h3 {
  color: #1e2329;
}

body.light_theme .df-widget-header h3::after {
  background: #1a1a1a;
}

body.light_theme .df-input-label {
  color: #1a1a1a;
}

body.light_theme .df-input-box {
  background: rgb(0 0 0 / 10%);
  border: 1px solid #f3f3f3;
}

body.light_theme .df-input-box input {
  color: #1a1a1a;
}

body.light_theme .df-currency-selector {
  color: #1a1a1a;
}

body.light_theme .df-method-fee {
  color: #585C63;
}

body.light_theme .df-method-desc {
  color: #585C63;
}

body.light_theme .df-payment-method {
  background: rgb(0 0 0 / 5%);
}

/* body.light_theme .df-method-icon {
  background: #fff;
} */

body.light_theme .df-method-title {
  color: #1e2329;
}

body.light_theme .df-section-title {
  color: #1a1a1a;
}

body.light_theme .df-why-card {
  background: #fff;
  border: 4px solid rgb(0 0 0 / 5%);
}

body.light_theme img.afterarrow {
  opacity: 0.1;
}

body.light_theme .df-why-card::before {
  background: #ffffff;
}

/* body.light_theme .df-why-card {
  background: #fafafa;
  border: 1px solid #f3f4f6;
} */

/* body.light_theme .df-why-icon {
  background: #fff;
} */

body.light_theme .df-why-card h4 {
  color: #1a1a1a;
}

body.light_theme .df-why-card p {
  color: #666;
}

body.light_theme .df-pairs-header h3 {
  color: #1a1a1a;
}

body.light_theme .df-pair-card {
  border: 1px solid #f3f4f6;
}

body.light_theme .df-pair-name {
  color: #707a8a;
}

body.light_theme .df-pair-price {
  color: #1a1a1a;
}

body.light_theme .df-banner-section {
  background: #fdf8ef;
}

body.light_theme .df-banner-content h2 {
  color: #1a1a1a;
}

body.light_theme .df-banner-content p {
  color: #707a8a;
}

body.light_theme .df-va-kicker,
body.light_theme .df-va-currency,
body.light_theme .df-va-label {
  color: #707a8a;
}

body.light_theme .df-va-value {
  color: #1e2329;
}

body.light_theme .df-va-beneficiary-note p {
  color: #1e2329;
}

body.light_theme .df-va-row {
  border-bottom-color: #eaecef;
}

body.light_theme .df-va-instructions {
  background: rgba(209, 170, 103, 0.08);
  color: #707a8a;
}

body.light_theme .df-guide-card {
  background: rgb(0 0 0 / 5%);
  border: 1px solid #d8d8d8;
  border-radius: 22px;
}

body.light_theme .df-guide-block__head {
  color: #1e2329;
}

body.light_theme .df-fee-stat span {
  color: #585C63;
}

body.light_theme .df-guide-block+.df-guide-block {
  border-top-color: #eaecef;
}

body.light_theme .df-guide-note,
body.light_theme .df-how-steps li {
  color: #5C626A;
}

body.light_theme .df-how-steps strong {
  color: #1e2329;
}

body.light_theme .df-fee-stat {
  background: rgb(0 0 0 / 3%);
  border-color: rgb(0 0 0 / 3%);
}

body.light_theme .df-fee-stat strong {
  color: #1e2329;
}

/* 
body.light_theme .df-va-row--iban {
  background: rgba(209, 170, 103, 0.08);
  border-color: rgba(209, 170, 103, 0.25);
} */

body.light_theme .df-fee-notice {
  color: #707a8a;
  background: rgba(209, 170, 103, 0.08);
}

body.light_theme .df-va-iban-missing {
  color: #8a6a2a;
}

body.light_theme .df-kyc-modal {
  background: #fff;
  border-color: #e1e1e1;
}

body.light_theme .df-kyc-modal-title {
  color: #101828;
}

body.light_theme .df-kyc-modal-text {
  color: #6a7282;
}

body.light_theme .df-kyc-modal-close {
  color: #111827;
}

body.light_theme .df-kyc-modal-close:hover {
  background: rgba(17, 24, 39, 0.06);
}

body.light_theme .df-faq-question {
  color: #1a1a1a;
}

body.light_theme .df-faq-answer {
  color: #666;
}

body.light_theme .df-deposit-history-title {
  color: #101828;
}

body.light_theme .df-dd-label {
  color: #707a8a;
}

body.light_theme .df-dd-trigger {
  background: #f3f3f3;
  border-color: #eaeaea;
  color: #1a1a1a;
}

body.light_theme .df-dd-menu {
  background: #fff;
  border-color: #eaeaea;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

body.light_theme .df-dd-option {
  color: #1a1a1a;
}

body.light_theme .df-dd-option:hover,
body.light_theme .df-dd-option.is-selected {
  background: rgba(209, 170, 103, 0.18);
  color: #b89353;
}

body.light_theme .df-deposit-history-empty-img {
  filter: invert(0);
}

body.light_theme .df-deposit-history-reason,
body.light_theme .df-deposit-history-empty-copy {
  color: #667085;
}

body.light_theme .df-fiat-deposit-detail-list dt {
  color: #667085;
}

body.light_theme .df-fiat-deposit-detail-list dd {
  color: #101828;
}

body.light_theme .df-deposit-history-row {
  border-top-color: #eaecf0;
  color: #101828;
}

body.light_theme .df-deposit-history-copy-btn {
  background: #f8fafc;
  border-color: rgba(148, 163, 184, 0.45);
  color: #334155;
}

body.light_theme .df-deposit-history-copy-btn:hover {
  background: #eef2ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #3730a3;
}

body.light_theme .df-deposit-history-action-badge.is-success {
  background: #ecfdf3;
  border-color: #a7f3d0;
}

body.light_theme .df-deposit-history-action-badge.is-pending {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}

body.light_theme .df-deposit-history-action-badge.is-neutral {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #334155;
}

body.light_theme .df-deposit-history-mobile-card {
  border-top-color: #eaecf0;
}

body.light_theme .df-deposit-history-mobile-date,
body.light_theme .df-deposit-history-mobile-value {
  color: #101828;
}

/* ========================================= */
/*     PAGE GLASS SKELETON (same layout)     */
/* ========================================= */
@keyframes df-sk-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.df-sk-glass {
  display: block;
  border-radius: 999px;
  background: linear-gradient(90deg,
      rgba(209, 170, 103, 0.1) 0%,
      rgba(255, 255, 255, 0.22) 48%,
      rgba(209, 170, 103, 0.1) 100%);
  background-size: 220% 100%;
  animation: df-sk-shimmer 1.4s ease-in-out infinite;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.df-sk-glass-panel {
  background: linear-gradient(90deg,
      rgba(209, 170, 103, 0.06) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(209, 170, 103, 0.06) 100%);
  background-size: 220% 100%;
  animation: df-sk-shimmer 1.4s ease-in-out infinite;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.df-sk-glass--tag {
  width: 140px;
  height: 16px;
  margin-bottom: 16px;
}

.df-sk-glass--h1 {
  width: 86%;
  height: 42px;
  margin-bottom: 10px;
  border-radius: 12px;
}

body.light_theme .df-feature-text p {
  color: #585C63;
}

body.light_theme .dividerbdr {
  background: linear-gradient(356deg, rgb(242 242 242) 0%, rgb(129 129 129) 50%, rgb(242 242 242) 100%);
}

body.light_theme .df-how-steps li::before {
  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgb(0 0 0 / 20%) 100%);
}

.df-sk-glass--h1s {
  width: 62%;
  height: 42px;
  margin-bottom: 22px;
  border-radius: 12px;
}

.df-sk-glass--lead {
  width: 92%;
  height: 16px;
  margin-bottom: 36px;
}

.df-sk-glass--icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid rgba(209, 170, 103, 0.45);
}

.df-sk-glass--feat-title {
  width: 180px;
  height: 14px;
  margin-bottom: 8px;
}

.df-sk-glass--feat-p {
  width: 260px;
  height: 12px;
}

.df-sk-glass--widget-title {
  width: 140px;
  height: 18px;
}

.df-sk-glass--pill {
  width: 120px;
  height: 28px;
}

.df-sk-glass--limit-label {
  width: 110px;
  height: 11px;
  margin-bottom: 8px;
}

.df-sk-glass--label {
  width: 72px;
  height: 11px;
  margin-bottom: 8px;
}

.df-sk-glass--line {
  width: 100%;
  height: 12px;
  margin-top: 10px;
}

.df-sk-glass--circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex-shrink: 0;
}

.df-sk-glass--submit {
  width: 100%;
  height: 52px;
  border-radius: 30px;
  margin-top: 8px;
}

.df-sk-glass--section-title {
  width: 320px;
  height: 28px;
  margin: 0 auto 28px;
}

.df-sk-glass--why-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin: 0 auto 16px;
}

.df-sk-glass--hist-title {
  width: 200px;
  height: 22px;
}

.df-sk-w60 {
  width: 60%;
}

.df-sk-w70 {
  width: 70%;
}

.df-sk-w80 {
  width: 80%;
}

.df-sk-w90 {
  width: 90%;
}

.df-sk-widget .df-limit-list {
  min-height: 86px;
}

.df-sk-glass-panel--input {
  min-height: 58px;
  border-radius: 12px;
}

.df-sk-widget .df-payment-method {
  min-height: 118px;
  align-items: center;
}

.df-sk-why-card {
  min-height: 160px;
}

.df-sk-table-wrap {
  padding-top: 8px;
}

.df-sk-table-head {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 0.8fr;
  gap: 16px;
  padding: 0 4px 14px;
  font-size: 13px;
  color: #84888c;
}

.df-sk-row {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 0.8fr;
  gap: 16px;
  align-items: center;
  padding: 16px 4px;
  border-top: 1px solid #2b3139;
}

.df-sk-coin {
  display: flex;
  align-items: center;
  gap: 12px;
}

.df-sk-coin-txt {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.df-sk-bone {
  display: block;
  border-radius: 999px;
}

.df-sk-bone--xs {
  width: 72px;
  height: 10px;
}

.df-sk-bone--xxs {
  width: 48px;
  height: 8px;
}

.df-sk-bone--cell {
  width: 88px;
  height: 12px;
  margin-left: auto;
}

.df-sk-bone--w50 {
  width: 50%;
}

.df-sk-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
}

.df-limit-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* padding: 14px 16px; */
  margin-bottom: 20px;
}

.df-limit-list__title {
  font-size: 21px;
  /* text-transform: uppercase; */
  font-weight: 700;
  color: #ffffff;
}

.df-limit-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #9CA3AF;
}

.df-limit-row strong {
  color: #fff;
  font-weight: 500;
  text-align: right;
}

.df-limit-row--sub strong {
  font-weight: 500;
  /* color: #d1aa67; */
}

body.light_theme .df-sk-glass {
  background: linear-gradient(90deg,
      rgba(209, 170, 103, 0.1) 0%,
      rgba(255, 255, 255, 0.85) 48%,
      rgba(209, 170, 103, 0.1) 100%);
  background-size: 220% 100%;
}

body.light_theme .df-sk-glass-panel,
body.light_theme .df-sk-widget .df-limit-list {
  background: linear-gradient(90deg,
      rgba(209, 170, 103, 0.08) 0%,
      rgba(255, 248, 236, 0.9) 50%,
      rgba(209, 170, 103, 0.08) 100%);
  background-size: 220% 100%;
}

body.light_theme .df-sk-row {
  border-color: #eaecef;
}

/* 
body.light_theme .df-limit-list {
  background: rgba(209, 170, 103, 0.08);
  border-color: rgba(209, 170, 103, 0.22);
} */

body.light_theme .df-limit-row strong {
  color: #1e2329;
}

body.light_theme .df-sk-bone,
body.light_theme .df-sk-circle {
  background: linear-gradient(90deg,
      rgba(209, 170, 103, 0.1) 0%,
      rgba(255, 255, 255, 0.85) 48%,
      rgba(209, 170, 103, 0.1) 100%);
  background-size: 220% 100%;
  animation: df-sk-shimmer 1.4s ease-in-out infinite;
}

body.light_theme .df-limit-list__title {
  color: #1e2329;
}

body.light_theme .df-limit-row {
  color: #585C63;
}


@media screen and (max-width:580px) {


  .df-hero-widget {
    padding: 15px;
  }



}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/DepositFiatPage/depositfiat.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,gCAAgC;EAChC,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,yBAAyB;EACzB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gCAAgC;EAChC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wFAAwF;AAC1F;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,+FAA+F;EAC/F,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB;oDACkD;;EAElD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yFAAyF;EACzF,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yFAAyF;EACzF,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sEAAsE;EACtE,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf;;;;wBAIsB;EACtB,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;;AAE9C;;;EAGE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;AAEF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;EAEE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB;;;oCAGkC;EAClC,0BAA0B;EAC1B,kDAAkD;EAClD,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE;;;qCAGmC;EACnC,0BAA0B;EAC1B,kDAAkD;EAClD,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;;;oCAGkC;EAClC,0BAA0B;AAC5B;;AAEA;;EAEE;;;qCAGmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;;EAEE;;;oCAGkC;EAClC,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;;EAGE;IACE,aAAa;EACf;;;;AAIF","sourcesContent":["/* ========================================= */\n/*              GLOBAL STYLES                */\n/* ========================================= */\n.deposit-fiat-wrapper {\n  font-family: \"Inter\", sans-serif;\n  color: #eaecef;\n  background: transparent;\n  line-height: 1.5;\n  width: 100%;\n}\n\n/* ========================================= */\n/*               HERO SECTION                */\n/* ========================================= */\n.df-hero-section {\n  background-position: top right;\n  background-repeat: no-repeat;\n  background-size: 580px;\n  padding: 72px 0 40px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 0;\n}\n\n.dashboard_right.fiatmobile {\n  padding-right: 0px;\n}\n\n.dashboard_right.fiatmobile .df-hero-container {\n  padding-right: 60px;\n}\n\nbody.light_theme .deposit-fiat-wrapper .df-hero-section {\n  background-image: none !important;\n}\n\n.df-hero-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  gap: 48px;\n}\n\n.df-hero-content {\n  flex: 1;\n  max-width: 800px;\n  min-width: 0;\n}\n\n.df-gateway-tag {\n  color: #d1aa67;\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.df-gateway-tag::after {\n  content: \"\";\n  height: 1px;\n  width: 40px;\n  background: #eaeaea;\n}\n\n.df-hero-content h1 {\n  font-size: 60px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: #eaecef;\n  line-height: 1.1;\n}\n\n.df-hero-content h1 span {\n  color: #d1aa67;\n}\n\n.df-hero-content>p {\n  font-size: 19px;\n  color: #94A3B8;\n  line-height: 1.6;\n  margin: 16px 0 24px;\n}\n\n.df-features-list {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n  padding: 5px 0px 10px;\n}\n\n.df-feature-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.df-feature-icon {\n  width: 60px;\n  height: 60px;\n  min-width: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.df-feature-icon img {\n  width: 100%;\n}\n\n.df-feature-text h4 {\n  font-size: 17px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 5px;\n}\n\n.df-feature-text p {\n  font-size: 14px;\n  color: #94A3B8;\n  margin: 0;\n  line-height: 1.45;\n}\n\n.df-hero-widget {\n  width: 580px;\n  flex-shrink: 0;\n  max-width: 100%;\n  background: rgb(255 255 255 / 5%);\n  border-radius: 30px;\n  box-shadow: 0 0px 20px rgba(0, 0, 0, 0.07);\n  padding: 32px;\n  border: 1px solid #656565;\n  backdrop-filter: blur(12px);\n}\n\n.df-widget-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.df-widget-header h3 {\n  font-size: 25px;\n  font-weight: 700;\n  position: relative;\n  color: #fff;\n}\n\n/* \n.df-widget-header h3::after {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  left: 0;\n  right: 0px;\n  margin: 0 auto;\n  width: 16px;\n  height: 3px;\n  background: #eaecef;\n  border-radius: 2px;\n} */\n\n.df-withdrawal-btn {\n  background: #D1AA67;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 6px 16px;\n  border-radius: 20px;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.df-withdrawal-btn:hover {\n  color: #fff;\n  opacity: 0.8;\n}\n\n.df-input-group {\n  margin-bottom: 25px;\n}\n\n.df-input-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #9CA3AF;\n  margin-bottom: 7px;\n  display: block;\n}\n\n.df-input-box {\n  background: rgb(255 255 255 / 5%);\n  border: 1px solid #5c5c5c;\n  border-radius: 50px;\n  padding: 18px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.df-input-box input {\n  background: transparent;\n  border: none;\n  font-size: 17px;\n  font-weight: 600;\n  color: #ffffff;\n  width: 100%;\n  outline: none;\n}\n\n.df-currency-selector {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  font-size: 15px;\n  color: #D1D5DB;\n  cursor: pointer;\n}\n\n.df-currency-icon {\n  width: 24px;\n  height: 24px;\n  background: #26a17b;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.df-payment-method {\n  flex-direction: column;\n  /* border: 2px solid #d1aa67; */\n  border-radius: 10px;\n  padding: 20px;\n  display: flex;\n  gap: 12px;\n  margin-bottom: 25px;\n  background: rgb(255 255 255 / 5%);\n}\n\n.df-method-icon {\n  width: 44px;\n  min-width: 44px;\n  height: 44px;\n  background: rgb(209 170 103 / 10%);\n  border: 1px solid rgb(209 170 103 / 20%);\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.df-method-icon img {\n  width: 22px;\n}\n\n.df-method-details {\n  flex: 1;\n}\n\n.df-method-title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.checkiconbnk {\n  width: 20px;\n  height: 20px;\n  background: #D1AA67;\n  border-radius: 50px;\n  min-width: 20px;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 900;\n}\n\n.df-input-box img {\n  width: 24px;\n  margin-right: 7px;\n}\n\n.df-method-title {\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.df-recommended-tag {\n  background: rgb(209 170 103 / 20%);\n  border: 1px solid rgb(209 170 103 / 30%);\n  color: #D1AA67;\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 50px;\n  font-weight: 600;\n}\n\n.df-check-icon {\n  color: #d1aa67;\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.df-method-fee {\n  font-size: 14px;\n  color: #9CA3AF;\n  margin-bottom: 4px;\n}\n\n.df-method-desc {\n  font-size: 14px;\n  color: #9CA3AF;\n}\n\n.paybl_methoddl {\n  display: flex;\n  width: 100%;\n  gap: 12px;\n}\n\n.kyc_complete {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.kyc_complete a {\n  color: #D1AA67;\n  text-decoration: underline;\n}\n\n.df-submit-btn {\n  background: #D1AA67;\n  color: #fff;\n  width: 100%;\n  padding: 15px;\n  text-align: center;\n  border-radius: 50px;\n  margin-top: 24px;\n  font-size: 17px;\n  min-height: 56px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.df-submit-btn:hover {\n  opacity: 0.95;\n  color: #fff;\n}\n\nbody.light_theme .df-payment-method.beneficiarynote p {\n  color: #454545;\n}\n\n.df-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.df-alert {\n  padding: 12px 16px;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.df-alert--error {\n  background: rgba(248, 113, 113, 0.12);\n  border: 1px solid rgba(248, 113, 113, 0.35);\n  color: #fca5a5;\n}\n\n.df-alert--info {\n  background: rgba(209, 170, 103, 0.1);\n  border: 1px solid rgba(209, 170, 103, 0.35);\n  color: #d1aa67;\n}\n\n/* ========================================= */\n/*          VIRTUAL ACCOUNT CARD             */\n/* ========================================= */\n.df-va-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.df-va-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.df-va-kicker {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #848e9c;\n  margin-bottom: 10px;\n}\n\n/* .df-hero-content h1 br {\n  display: none;\n} */\n\n.df-va-status-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.df-va-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid rgb(16 185 129 / 30%);\n  font-size: 10px;\n  font-weight: 600;\n  background: rgb(16 185 129 / 10%);\n  color: #34D399;\n}\n\n.df-va-status--pending {\n  background: rgba(209, 170, 103, 0.15);\n  color: #d1aa67;\n}\n\n.df-va-currency {\n  font-size: 13px;\n  font-weight: 500;\n  color: #848e9c;\n}\n\n.df-va-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 10px 0;\n}\n\n.df-va-label {\n  font-size: 15px;\n  color: #9CA3AF;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.df-va-value {\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  text-align: right;\n  word-break: normal;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.df-va-value--iban {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.df-va-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.df-va-num-text {\n  white-space: nowrap;\n  letter-spacing: 0.5px;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.df-va-copy {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0px;\n  padding: 0px 2px;\n  border: none;\n  background: transparent;\n  color: #9CA3AF;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n/* .df-va-copy:hover {\n  background: rgba(209, 170, 103, 0.12);\n} */\n\n.df-va-copy i {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.df-va-iban-missing {\n  margin: 8px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #d1aa67;\n}\n\n.df-guide-card {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border-radius: 22px 22px 0px 0px;\n  padding: 34px;\n  border: 1px solid #23262C;\n  border-bottom: none;\n  background: linear-gradient(180deg, rgba(30, 33, 39, 1) 0%, rgba(23, 26, 32, 1) 100%);\n  overflow: hidden;\n  text-align: left;\n}\n\n.df-guide-block+.df-guide-block {\n  margin-top: 32px;\n}\n\n.df-guide-block__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 20px;\n  font-weight: 700;\n  /* letter-spacing: 0.06em; */\n  /* text-transform: uppercase; */\n  color: #fff;\n}\n\n.df-guide-block__icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(209, 170, 103, 0.12);\n  color: #d1aa67;\n}\n\n.df-fee-stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 32px;\n  margin-bottom: 14px;\n}\n\n.df-fee-stat {\n  padding: 20px;\n  border-radius: 16px;\n  background: rgb(255 255 255 / 3%);\n}\n\n.df-fee-stat span {\n  display: block;\n  font-size: 15px;\n  color: #94A3B8;\n  margin-bottom: 6px;\n}\n\n.df-fee-stat strong {\n  display: block;\n  font-size: 22px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.3;\n}\n\n.df-fee-stat__ok {\n  color: #22c55e;\n}\n\n.df-guide-note {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #94A3B8;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.df-how-steps {\n  margin: 0px;\n  padding: 5px 0px 0px;\n  list-style: none;\n  counter-reset: df-how;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.df-how-steps li {\n  counter-increment: df-how;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  font-size: 17px;\n  line-height: 1.5;\n  color: #CBD5E1;\n}\n\n.df-how-steps li::before {\n  content: counter(df-how);\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(23, 26, 32, 0) 100%);\n}\n\n.df-how-steps li>span {\n  flex: 1;\n  min-width: 0;\n}\n\n.dividerbdr {\n  max-width: 730px;\n  height: 1.40px;\n  background: linear-gradient(356deg, rgb(23 26 32) 0%, rgb(129 129 129) 50%, rgb(25 27 34) 100%);\n  margin: 28px 0px;\n}\n\n.df-how-steps strong {\n  color: #ffffff;\n  font-weight: 400;\n}\n\n.df-va-row--iban {\n  /* padding: 12px 12px; */\n  /* margin: 4px -12px 0; */\n  /* border-radius: 10px; */\n  /* border-bottom: none; */\n  /* background: rgba(209, 170, 103, 0.08); \n    /* border: 1px solid rgba(209, 170, 103, 0.22);*/\n\n  width: 100%;\n}\n\n.df-payment-method.beneficiarynote {\n  flex-direction: row;\n  margin-top: 32px;\n  border-radius: 16px;\n}\n\n\n.df-payment-method.beneficiarynote p {\n  font-size: 13px;\n  color: #D1D5DB;\n}\n\n.df-va-instructions {\n  margin-top: 8px;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px dashed rgba(209, 170, 103, 0.45);\n  background: rgba(209, 170, 103, 0.06);\n  font-size: 13px;\n  line-height: 1.6;\n  color: #848e9c;\n}\n\n.df-va-instructions strong {\n  color: #d1aa67;\n}\n\n.df-fee-notice {\n  margin: 0 0 16px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(209, 170, 103, 0.35);\n  background: rgba(209, 170, 103, 0.08);\n  font-size: 13px;\n  line-height: 1.55;\n  color: #848e9c;\n}\n\n.df-fee-notice p {\n  margin: 0 0 8px;\n}\n\n.df-fee-notice p:last-child {\n  margin-bottom: 0;\n}\n\n.df-va-card .df-limit-list,\n.df-hero-widget .df-limit-list {\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n\n.df-va-card .df-input-group {\n  margin-bottom: 16px;\n}\n\n.df-va-card .df-submit-btn {\n  margin-top: 4px;\n  margin-bottom: 16px;\n}\n\n.df-va-beneficiary-note {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin-top: 16px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(209, 170, 103, 0.55);\n  background: rgba(209, 170, 103, 0.08);\n}\n\n.df-va-beneficiary-note__icon {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(107, 87, 53, 1) 100%);\n  color: #1a1408;\n  font-size: 13px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.df-va-beneficiary-note p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #eaecef;\n}\n\n.df-va-add-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  margin-top: 14px;\n  padding: 14px 16px;\n  border: none;\n  border-radius: 30px;\n  background: #d1aa67;\n  color: #1a1408;\n  font-size: 15px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.df-va-add-btn:hover {\n  color: #1a1408;\n  opacity: 0.9;\n}\n\n.df-intent-max {\n  flex-shrink: 0;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid #d1aa67;\n  background: transparent;\n  color: #d1aa67;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.df-intent-max:hover:not(:disabled) {\n  background: rgba(209, 170, 103, 0.12);\n}\n\n.df-intent-max:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.df-intent-box {\n  margin: 0 0 16px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(209, 170, 103, 0.45);\n  background: rgba(209, 170, 103, 0.08);\n  color: #eaecef;\n}\n\n.df-intent-box strong {\n  display: block;\n  margin-bottom: 6px;\n  color: #d1aa67;\n  font-size: 15px;\n}\n\n.df-intent-box p {\n  margin: 0 0 6px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #848e9c;\n}\n\n.df-intent-box p:last-child {\n  margin-bottom: 0;\n}\n\n.df-intent-open {\n  margin: 12px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.df-intent-open li {\n  margin: 0 0 8px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #2b3139;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #eaecef;\n}\n\n.df-intent-open li:last-child {\n  margin-bottom: 0;\n}\n\n/* ========================================= */\n/*               KYC MODAL                   */\n/* ========================================= */\n.df-kyc-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.62);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.df-kyc-modal {\n  width: 560px;\n  max-width: 100%;\n  position: relative;\n  text-align: center;\n  padding: 28px 24px 24px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: #181a20;\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.5);\n}\n\n.df-kyc-modal-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #8e939c;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.df-kyc-modal-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\n.df-kyc-modal-art {\n  margin: 8px auto 12px;\n  max-width: 180px;\n}\n\n.df-kyc-modal-art img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.df-kyc-modal-title {\n  margin: 12px 0 10px;\n  font-size: 22px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.df-kyc-modal-text {\n  margin: 0 0 22px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #84888c;\n}\n\n.df-kyc-modal-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.df-kyc-modal-confirm {\n  min-width: 220px;\n  height: 46px;\n  border: none;\n  border-radius: 999px;\n  background: #d1aa67;\n  color: #0c0d10;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.df-kyc-modal-confirm:hover {\n  background: #c49a55;\n}\n\n/* ========================================= */\n/*               WHY DEPOSIT                 */\n/* ========================================= */\n.df-why-section {\n  padding: 80px 0px;\n  text-align: center;\n}\n\nbody.light_theme .depositcrypto_lft .deposit_history_row {\n  border-top: 1px solid #dadada;\n}\n\n.df-section-title {\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  margin-bottom: 50px;\n  color: #eaecef;\n  position: relative;\n  z-index: 999;\n}\n\n/* .df-section-title span {\n  color: #d1aa67;\n} */\n\n.df-why-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 85px;\n  margin-top: 110px;\n}\n\n.df-why-card {\n  width: 280px;\n  background: #171a20;\n  /* box-shadow: 0px 0px 10px #00000010; */\n  border: 4px solid rgb(255 255 255 / 18%);\n  border-radius: 32px;\n  position: relative;\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  text-align: left;\n  transition: 0.3s;\n}\n\n.df-why-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n}\n\n.df-why-card::before {\n  position: absolute;\n  content: \"\";\n  right: -10px;\n  top: -30px;\n  height: 90%;\n  width: 85%;\n  background: #171a20;\n}\n\nimg.afterarrow {\n  width: 68px;\n  position: absolute;\n  bottom: 37px;\n  right: -68px;\n}\n\n.df-why-card:last-child img.afterarrow {\n  display: none;\n}\n\n.df-why-icon {\n  width: 70px;\n  height: 70px;\n  min-width: 70px;\n  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgba(107, 87, 53, 1) 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0px;\n}\n\n.df-why-icon img {\n  width: 32px;\n}\n\n.df-why-card h4 {\n  color: #fff;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #fff;\n  min-width: 160px;\n}\n\n.df-why-card p {\n  font-size: 17px;\n  color: #fff;\n  line-height: 1.6;\n  position: relative;\n  z-index: 999;\n}\n\n.tophd_how {\n  gap: 15px;\n  position: relative;\n  margin-top: -67px;\n  margin-left: 20px;\n  margin-bottom: 36px;\n}\n\n.tophd_how h4 {\n  margin-bottom: 0px;\n}\n\n/* ========================================= */\n/*               POPULAR PAIRS               */\n/* ========================================= */\n.df-pairs-section {\n  padding: 40px 0 80px 0;\n}\n\n.df-pairs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.df-pairs-header h3 {\n  color: #eaecef;\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  margin-bottom: 5px;\n}\n\n.df-deposit-link {\n  color: #d1aa67;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.df-deposit-link:hover {\n  color: #d1aa67;\n  opacity: 0.8;\n}\n\n.df-pairs-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.df-pair-card {\n  border: 1px solid #2b3139;\n  border-radius: 14px;\n  padding: 28px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: 0.2s;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);\n}\n\n.df-pair-card:hover {\n  border-color: #d1aa67;\n}\n\n.df-pair-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.df-pair-name {\n  font-size: 20px;\n  font-weight: 600;\n  color: #848e9c;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.df-pair-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.df-pair-icon.usdt {\n  background: #26a17b;\n}\n\n.df-pair-icon.btc {\n  background: #f7931a;\n}\n\n.df-pair-icon.eth {\n  background: #627eea;\n}\n\n.df-pair-price {\n  color: #eaecef;\n  font-size: 20px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.df-pair-change {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.df-pair-change.positive {\n  color: #22c55e;\n}\n\n.df-pair-change.negative {\n  color: #ef4444;\n}\n\n.df-pair-chart svg {\n  width: 90px;\n  height: 60px;\n}\n\n.df-pair-chart.positive svg {\n  color: #26a17b;\n}\n\n.df-pair-chart.negative svg {\n  color: #e25b4d;\n}\n\n/* ========================================= */\n/*               BANNER SECTION              */\n/* ========================================= */\n.df-banner-section {\n  margin-bottom: 100px;\n  background: #1e2329;\n  border-radius: 16px;\n  padding: 30px 60px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.df-banner-content h2 {\n  font-size: 44px;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: #eaecef;\n}\n\n.df-banner-content p {\n  font-size: 18px;\n  color: #848e9c;\n}\n\n.df-banner-img {\n  height: 240px;\n  margin-right: 40px;\n  padding-top: 10px;\n}\n\n/* ========================================= */\n/*                  FAQ SECTION              */\n/* ========================================= */\n.df-faq-section {\n  margin-bottom: 100px;\n}\n\n.df-faq-section h2 {\n  font-size: 40px;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 40px;\n}\n\n.df-faq-item {\n  border-bottom: 1px solid #eaeaea2e;\n}\n\nbody.light_theme .df-faq-item {\n  border-bottom: 1px solid #eaeaea;\n}\n\n.df-faq-question {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #eaecef;\n  padding: 24px 0;\n}\n\n.df-faq-answer {\n  padding-bottom: 24px;\n  font-size: 15px;\n  color: #848e9c;\n  line-height: 1.6;\n}\n\n/* ========================================= */\n/*          DEPOSIT FIAT HISTORY             */\n/* ========================================= */\n.df-deposit-history-section {\n  padding: 0 0 80px;\n  overflow: visible;\n}\n\n.df-deposit-history-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.df-deposit-history-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\n.df-deposit-history-filters {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.df-dd {\n  position: relative;\n  min-width: 140px;\n}\n\n.df-dd-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #848e9c;\n  letter-spacing: 0.02em;\n}\n\n.df-dd-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #2b3139;\n  background: #181a20;\n  color: #eaecef;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.df-dd-trigger:hover,\n.df-dd-trigger.is-open {\n  border-color: #3a414b;\n}\n\n.df-dd-trigger:focus-visible {\n  outline: none;\n  border-color: #d1aa67;\n}\n\n.df-dd-value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.df-dd-chevron {\n  flex-shrink: 0;\n  color: #848e9c;\n  transition: transform 0.15s ease;\n}\n\n.df-dd.is-open .df-dd-chevron {\n  transform: rotate(180deg);\n}\n\n.df-dd-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 30;\n  margin: 0;\n  padding: 6px 0;\n  list-style: none;\n  border-radius: 8px;\n  border: 1px solid #2b3139;\n  background: #1e2329;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);\n  overflow: hidden;\n}\n\n.df-dd-option {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  color: #eaecef;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n}\n\n.df-dd-option:hover,\n.df-dd-option.is-selected {\n  background: rgba(209, 170, 103, 0.16);\n  color: #d1aa67;\n}\n\n.df-deposit-history-export-btn {\n  height: 38px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid #d1aa67;\n  background: transparent;\n  color: #d1aa67;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease;\n}\n\n.df-deposit-history-export-btn:hover:not(:disabled) {\n  background: #d1aa67;\n  color: #181a20;\n}\n\n.df-deposit-history-export-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.df-deposit-history-card {\n  overflow: visible;\n}\n\n.df-deposit-history-table-wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  min-width: 0;\n}\n\n.df-deposit-history-status {\n  margin: 0;\n  padding: 16px 4px;\n  font-size: 13px;\n  color: #848e9c;\n}\n\n.df-deposit-history-status p {\n  margin: 0 0 12px;\n}\n\n.df-deposit-history-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 72px 16px 88px;\n  text-align: center;\n}\n\n.df-deposit-history-empty-img {\n  width: 120px;\n  height: auto;\n  max-width: 100%;\n  opacity: 0.9;\n  filter: invert(1);\n}\n\n.df-deposit-history-head-wrap {\n  overflow: visible;\n}\n\n.df-deposit-history-head,\n.df-deposit-history-row {\n  display: grid;\n  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;\n  gap: 8px;\n  align-items: center;\n  min-width: 1240px;\n}\n\n.df-deposit-history-desktop--fiat .df-deposit-history-head,\n.df-deposit-history-desktop--fiat .df-deposit-history-row {\n  grid-template-columns: 1.2fr 1fr 0.9fr 0.7fr 1.5fr;\n  min-width: 0;\n}\n\n.df-deposit-history-reason {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #84888c;\n  white-space: normal;\n  line-height: 1.35;\n}\n\n.df-deposit-history-more {\n  display: flex;\n  justify-content: center;\n  padding: 16px 0 8px;\n}\n\n.df-deposit-history-empty-copy {\n  margin: 8px 0 0;\n  color: #84888c;\n  font-size: 14px;\n  text-align: center;\n}\n\n.df-fiat-deposit-detail-list {\n  display: grid;\n  gap: 14px;\n  margin: 12px 0 0;\n}\n\n.withdraw_hist_detail_modal.wf-fiat-detail-modal {\n  max-height: none;\n  overflow: visible;\n  padding: 18px 22px 16px;\n  width: 520px;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_stepper {\n  margin-top: 12px;\n}\n\nbody.light_theme .df-kyc-modal-overlay {\n  background: rgb(255 255 255 / 62%);\n}\n\n.wf-fiat-detail-modal .withdraw_hist_step_note {\n  margin-top: 2px;\n  margin-bottom: 0;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_rows {\n  margin-top: 12px;\n  padding-top: 10px;\n  gap: 8px;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_row {\n  padding: 0;\n  min-height: 0;\n}\n\n.wf-fiat-detail-modal .withdraw_hist_row_label,\n.wf-fiat-detail-modal .withdraw_hist_row_value {\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.wf-fiat-detail-help {\n  margin-top: 10px;\n  padding-left: 0;\n  text-align: center;\n  align-items: center;\n}\n\n.df-fiat-deposit-detail-list>div {\n  min-width: 0;\n}\n\n.df-fiat-deposit-detail-list dt {\n  margin: 0 0 4px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #84888c;\n}\n\n.df-fiat-deposit-detail-list dd {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #cecece;\n}\n\n.df-deposit-history-head {\n  padding: 10px 0;\n}\n\n.df-deposit-history-head-cell {\n  font-size: 13px;\n  font-weight: 400;\n  color: #84888c;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.df-deposit-history-body-wrap {\n  min-width: 0;\n}\n\n.df-deposit-history-row {\n  padding: 12px 0;\n  border-top: 1px solid #2b3139;\n  font-size: 13px;\n  font-weight: 500;\n  color: #cecece;\n  line-height: 1.3;\n  align-items: start;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.df-deposit-history-row-cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.df-deposit-history-row-cell--action {\n  text-transform: capitalize;\n}\n\n.df-deposit-history-desktop--fiat .df-deposit-history-row-cell--action {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  text-transform: none;\n  white-space: normal;\n  overflow: visible;\n}\n\n.df-deposit-history-trunc {\n  display: inline-block;\n  vertical-align: middle;\n  max-width: calc(100% - 72px);\n}\n\n.df-deposit-history-copy-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  background: #1f2937;\n  color: #e2e8f0;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.05s ease;\n  padding: 0;\n  line-height: 1;\n  text-decoration: none;\n}\n\n.df-deposit-history-copy-btn:hover {\n  background: rgba(209, 170, 103, 0.18);\n  border-color: rgba(209, 170, 103, 0.55);\n  color: #d1aa67;\n}\n\n.df-deposit-history-copy-btn:active {\n  transform: translateY(0.5px);\n}\n\n.df-deposit-history-copy-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(209, 170, 103, 0.25);\n}\n\n.df-deposit-history-action-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.df-deposit-history-action-badge.is-success {\n  background: #ecfdf31a;\n  border-color: #a7f3d024;\n  color: #0c935a;\n}\n\n.df-deposit-history-action-badge.is-pending {\n  background: #fffbeb17;\n  border-color: #fde68a1a;\n  color: #cd7641;\n}\n\n.df-deposit-history-action-badge.is-danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b42318;\n}\n\n.df-deposit-history-action-badge.is-info {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n\n.df-deposit-history-action-badge.is-neutral {\n  background: rgba(148, 163, 184, 0.12);\n  border-color: rgba(148, 163, 184, 0.22);\n  color: #e2e8f0;\n}\n\n.df-deposit-history-mobile {\n  display: none;\n}\n\n.df-deposit-history-mobile-card {\n  padding: 16px 0;\n  border-top: 1px solid #2b3139;\n  cursor: pointer;\n}\n\n.df-deposit-history-mobile-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n}\n\n.df-deposit-history-mobile-date {\n  font-size: 13px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\n.df-deposit-history-mobile-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 6px 0;\n}\n\n.df-deposit-history-mobile-label {\n  font-size: 13px;\n  color: #848e9c;\n}\n\n.df-deposit-history-mobile-value {\n  font-size: 13px;\n  font-weight: 500;\n  color: #eaecef;\n  text-align: right;\n}\n\n.df-deposit-history-mobile-value--actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-width: 72%;\n}\n\n@media (max-width: 991.98px) {\n  .df-deposit-history-desktop {\n    display: none !important;\n  }\n\n  .df-deposit-history-mobile {\n    display: block !important;\n  }\n\n  .df-deposit-history-table-wrap {\n    overflow-x: visible;\n  }\n\n  .df-deposit-history-top {\n    align-items: flex-start;\n  }\n}\n\n/* ========================================= */\n/*               RESPONSIVE                  */\n/* ========================================= */\n\n@media (max-width: 1750px) {\n\n\n  .df-why-card {\n    width: 240px;\n    padding: 20px;\n  }\n\n  .df-hero-content h1 {\n    font-size: 52px;\n  }\n\n  .df-why-card p {\n    font-size: 15px;\n  }\n\n  .df-why-card h4 {\n    font-size: 20px;\n  }\n\n}\n\n\n@media (max-width: 1550px) {\n\n  .df-why-card {\n    width: 200px;\n    padding: 20px;\n  }\n\n  .df-why-card p {\n    font-size: 15px;\n  }\n\n  .df-why-card h4 {\n    font-size: 20px;\n    min-width: 130px;\n  }\n\n  .df-why-icon {\n    width: 54px;\n    height: 54px;\n    min-width: 54px;\n  }\n\n  img.afterarrow {\n    right: -58px;\n    width: 58px;\n    bottom: 40px;\n  }\n\n  .df-why-grid {\n    gap: 48px;\n    margin-top: 100px;\n  }\n\n}\n\n@media (max-width: 1440px) {\n  .df-hero-content h1 {\n    font-size: 44px;\n  }\n\n  .dashboard_right .container {\n    max-width: 100%;\n  }\n\n  .df-hero-widget {\n    width: 500px;\n  }\n\n  .df-hero-content>p {\n    font-size: 17px;\n  }\n\n  .df-feature-icon {\n    width: 42px;\n    height: 42px;\n    min-width: 42px;\n  }\n\n}\n\n@media (max-width: 1376px) {\n  .df-hero-content h1 {\n    font-size: 36px;\n  }\n\n  .df-hero-widget {\n    width: 420px;\n  }\n\n  .df-section-title {\n    font-size: 32px;\n    margin-bottom: 30px;\n  }\n\n}\n\n@media (max-width: 1200px) {\n  .container.df-hero-container {\n    flex-direction: column;\n  }\n\n  .df-hero-section {\n    padding: 30px 0px;\n  }\n\n  .df-hero-content h1 {\n    font-size: 32px;\n  }\n\n  .dashboard_right.fiatmobile .df-hero-container {\n    padding-right: 30px;\n  }\n\n  .df-hero-content>p {\n    font-size: 16px;\n    margin: 20px 0px 24px;\n  }\n\n  .df-hero-widget {\n    width: 100%;\n  }\n\n  .df-why-section {\n    padding: 40px 0px;\n  }\n\n  .df-why-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 28px;\n    margin-top: 80px;\n    row-gap: 72px;\n  }\n\n  .tophd_how {\n    margin-top: -49px;\n    margin-bottom: 16px;\n  }\n\n  .df-why-card:last-child img.afterarrow {\n    display: block;\n  }\n\n  img.afterarrow {\n    right: -58px;\n    width: 58px;\n    bottom: 38px;\n  }\n\n  .df-section-title {\n    font-size: 32px;\n    margin-bottom: 30px;\n  }\n\n  .df-pairs-section {\n    padding: 10px 0 40px 0;\n  }\n\n  .df-pairs-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .df-pairs-header h3 {\n    color: #eaecef;\n    font-size: 32px;\n  }\n\n  .df-banner-section {\n    margin-bottom: 60px;\n    padding: 20px 30px;\n  }\n\n  .df-banner-img {\n    margin-right: 0px;\n  }\n\n  .df-banner-content h2 {\n    font-size: 32px;\n  }\n\n  .df-faq-section h2 {\n    font-size: 32px;\n    margin-bottom: 20px;\n  }\n}\n\n@media (max-width: 991px) {\n  .dashboard_right.fiatmobile {\n    padding: 0px;\n  }\n\n  .df-hero-content {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .df-hero-widget {\n    width: 100%;\n  }\n\n  .df-hero-section {\n    padding: 30px 0px 10px;\n  }\n\n  .df-gateway-tag {\n    font-size: 15px;\n  }\n\n  .df-hero-content h1 {\n    font-size: 28px;\n  }\n\n  .df-widget-header h3 {\n    font-size: 22px;\n    margin: 0px;\n  }\n\n  .df-submit-btn {\n    padding: 13px;\n    font-size: 15px;\n    min-height: 100%;\n  }\n\n  img.afterarrow {\n    bottom: 35px;\n  }\n\n  .df-why-card {\n    width: 240px;\n  }\n\n  .df-hero-content>p {\n    font-size: 15px;\n    margin: 18px 0px 24px;\n  }\n\n  .df-why-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .df-pairs-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .df-banner-section {\n    gap: 30px;\n    padding: 40px 30px;\n    margin-bottom: 50px;\n  }\n\n  .df-hero-container {\n    gap: 30px;\n  }\n\n  .df-section-title {\n    font-size: 26px;\n  }\n\n  .df-pairs-header h3 {\n    color: #eaecef;\n    font-size: 26px;\n  }\n\n  .df-banner-content h2 {\n    font-size: 28px;\n  }\n\n  .df-faq-section h2 {\n    font-size: 26px;\n  }\n\n  .df-why-section {\n    padding: 40px 0px;\n  }\n}\n\n@media (max-width: 767px) {\n\n  section.df-deposit-history-section.depositfiathistory {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .df-va-card .df-limit-list,\n  .df-hero-widget .df-limit-list {\n    margin-bottom: 20px;\n  }\n\n  .df-hero-container {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .df-how-steps {\n    flex-direction: row;\n  }\n\n  .df-how-steps li {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .df-why-grid {\n    grid-template-columns: repeat(2, 1fr);\n    margin-top: 60px;\n  }\n\n  .df-hero-content h1 {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n\n  .df-gateway-tag {\n    font-size: 14px;\n    justify-content: center;\n  }\n\n  .df-feature-item {\n    text-align: left;\n  }\n\n  .df-features-list {\n    grid-template-columns: 1fr 1fr;\n    gap: 18px;\n  }\n\n  .df-hero-content>p {\n    margin: 10px 0px 15px;\n  }\n\n  .df-fee-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .df-feature-icon {\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n  }\n\n  .df-feature-text h4 {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .df-feature-text p {\n    font-size: 13px;\n  }\n\n  .df-hero-widget {\n    width: 100%;\n    padding: 24px;\n    text-align: left;\n  }\n\n  .df-va-head {\n    flex-direction: column;\n  }\n\n  .df-kyc-modal {\n    padding: 24px 16px 20px;\n  }\n\n  .df-kyc-modal-title {\n    font-size: 20px;\n  }\n\n  .df-kyc-modal-confirm {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .df-submit-btn {\n    width: 100%;\n    padding: 10px;\n    margin-top: 0px;\n    font-size: 13px;\n  }\n\n  .df-payment-method {\n    padding: 18px;\n    margin-bottom: 20px;\n  }\n\n  .df-hero-section {\n    padding: 30px 0px 10px;\n  }\n\n  .df-input-box input {\n    font-size: 15px;\n  }\n\n  .df-banner-img {\n    width: 200px;\n    height: auto;\n  }\n\n  .df-why-section {\n    padding: 30px 0px;\n  }\n\n  .df-section-title {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n\n  .df-deposit-history-title {\n    font-size: 18px;\n  }\n\n  .df-dd {\n    min-width: 120px;\n  }\n\n  .df-pairs-header h3 {\n    color: #eaecef;\n    font-size: 20px;\n  }\n\n  .df-deposit-link {\n    font-size: 13px;\n  }\n\n  .df-pair-name {\n    font-size: 16px;\n  }\n\n  .df-pair-price {\n    color: #eaecef;\n    font-size: 18px;\n  }\n\n  .df-pairs-section {\n    padding: 40px 0 40px 0;\n  }\n\n  .df-banner-content h2 {\n    font-size: 24px;\n  }\n\n  .df-banner-content p {\n    font-size: 15px;\n  }\n\n  .df-guide-card {\n    padding: 22px;\n  }\n}\n\n@media (max-width: 580px) {\n\n  .df-fee-stat strong {\n    font-size: 18px;\n  }\n\n  .df-hero-content h1 {\n    font-size: 22px;\n  }\n\n  .df-why-card p {\n    font-size: 13px;\n  }\n\n  .df-fee-stat span {\n    font-size: 13px;\n  }\n\n  .df-fee-stats {\n    gap: 20px;\n  }\n\n  .df-guide-note {\n    font-size: 14px;\n  }\n\n  .dividerbdr {\n    margin: 18px 0px;\n  }\n\n  .df-widget-header h3 {\n    font-size: 20px;\n  }\n\n  .df-withdrawal-btn {\n    font-size: 13px;\n  }\n\n  .df-limit-list__title {\n    font-size: 18px !important;\n  }\n\n  .df-banner-section {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n    padding: 28px;\n    margin-bottom: 30px;\n  }\n\n  .df-how-steps li {\n    font-size: 11px;\n  }\n\n  .df-va-value {\n    font-size: 12px;\n  }\n\n  .df-limit-row {\n    font-size: 12px;\n  }\n\n  .df-faq-section h2 {\n    font-size: 24px;\n    margin-bottom: 18px;\n  }\n\n  .df-feature-item {\n    text-align: center;\n    flex-direction: column;\n  }\n\n  .df-feature-icon {\n    margin: 0 auto;\n  }\n\n  .df-faq-question {\n    font-size: 15px;\n    padding: 15px 0;\n  }\n\n  .df-faq-answer {\n    padding-bottom: 18px;\n    font-size: 14px;\n  }\n\n  .df-pairs-section {\n    padding: 20px 0 40px 0;\n  }\n\n  .df-method-title {\n    flex-direction: column;\n    font-size: 16px;\n    align-items: start;\n    margin-bottom: 5px;\n  }\n\n  .df-section-title {\n    font-size: 22px;\n  }\n\n  .df-why-grid {\n    grid-template-columns: repeat(1, 1fr);\n    margin-top: 20px;\n    row-gap: 24px;\n  }\n\n  .df-why-card::before {\n    display: none;\n  }\n\n  .df-why-card {\n    border: 2px solid rgb(255 255 255 / 18%);\n  }\n\n  .df-why-card:last-child img.afterarrow {\n    display: none;\n  }\n\n  .df-why-icon {\n    width: 40px;\n    height: 40px;\n    padding: 8px;\n    min-width: 40px;\n  }\n\n  .df-why-card h4 {\n    font-size: 18px;\n  }\n\n  .df-hero-content>p {\n    font-size: 14px;\n  }\n\n  img.afterarrow {\n    display: none;\n  }\n\n  .df-why-card {\n    width: 100%;\n  }\n\n  .tophd_how {\n    margin-top: 0px;\n    margin-bottom: 12px;\n    margin-left: 0px;\n  }\n\n  .df-why-card h4 {\n    min-width: auto;\n  }\n\n\n}\n\n/* ========================================= */\n/*               LIGHT THEME                 */\n/* ========================================= */\nbody.light_theme .deposit-fiat-wrapper {\n  color: #1a1a1a;\n  background: #ffffff;\n}\n\nbody.light_theme .df-hero-content h1 {\n  color: #1e2329;\n}\n\nbody.light_theme .df-hero-content>p {\n  color: #707a8a;\n}\n\nbody.light_theme .df-feature-text h4 {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-feature-item {\n  background: #fff;\n  border-color: #eaecef;\n}\n\nbody.light_theme .df-hero-widget {\n  background: rgb(0 0 0 / 5%);\n  border: 1px solid #f2f2f2;\n  box-shadow: inset 0px 4px 20px #e5e5e5;\n}\n\nbody.light_theme .df-widget-header h3 {\n  color: #1e2329;\n}\n\nbody.light_theme .df-widget-header h3::after {\n  background: #1a1a1a;\n}\n\nbody.light_theme .df-input-label {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-input-box {\n  background: rgb(0 0 0 / 10%);\n  border: 1px solid #f3f3f3;\n}\n\nbody.light_theme .df-input-box input {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-currency-selector {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-method-fee {\n  color: #585C63;\n}\n\nbody.light_theme .df-method-desc {\n  color: #585C63;\n}\n\nbody.light_theme .df-payment-method {\n  background: rgb(0 0 0 / 5%);\n}\n\n/* body.light_theme .df-method-icon {\n  background: #fff;\n} */\n\nbody.light_theme .df-method-title {\n  color: #1e2329;\n}\n\nbody.light_theme .df-section-title {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-why-card {\n  background: #fff;\n  border: 4px solid rgb(0 0 0 / 5%);\n}\n\nbody.light_theme img.afterarrow {\n  opacity: 0.1;\n}\n\nbody.light_theme .df-why-card::before {\n  background: #ffffff;\n}\n\n/* body.light_theme .df-why-card {\n  background: #fafafa;\n  border: 1px solid #f3f4f6;\n} */\n\n/* body.light_theme .df-why-icon {\n  background: #fff;\n} */\n\nbody.light_theme .df-why-card h4 {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-why-card p {\n  color: #666;\n}\n\nbody.light_theme .df-pairs-header h3 {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-pair-card {\n  border: 1px solid #f3f4f6;\n}\n\nbody.light_theme .df-pair-name {\n  color: #707a8a;\n}\n\nbody.light_theme .df-pair-price {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-banner-section {\n  background: #fdf8ef;\n}\n\nbody.light_theme .df-banner-content h2 {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-banner-content p {\n  color: #707a8a;\n}\n\nbody.light_theme .df-va-kicker,\nbody.light_theme .df-va-currency,\nbody.light_theme .df-va-label {\n  color: #707a8a;\n}\n\nbody.light_theme .df-va-value {\n  color: #1e2329;\n}\n\nbody.light_theme .df-va-beneficiary-note p {\n  color: #1e2329;\n}\n\nbody.light_theme .df-va-row {\n  border-bottom-color: #eaecef;\n}\n\nbody.light_theme .df-va-instructions {\n  background: rgba(209, 170, 103, 0.08);\n  color: #707a8a;\n}\n\nbody.light_theme .df-guide-card {\n  background: rgb(0 0 0 / 5%);\n  border: 1px solid #d8d8d8;\n  border-radius: 22px;\n}\n\nbody.light_theme .df-guide-block__head {\n  color: #1e2329;\n}\n\nbody.light_theme .df-fee-stat span {\n  color: #585C63;\n}\n\nbody.light_theme .df-guide-block+.df-guide-block {\n  border-top-color: #eaecef;\n}\n\nbody.light_theme .df-guide-note,\nbody.light_theme .df-how-steps li {\n  color: #5C626A;\n}\n\nbody.light_theme .df-how-steps strong {\n  color: #1e2329;\n}\n\nbody.light_theme .df-fee-stat {\n  background: rgb(0 0 0 / 3%);\n  border-color: rgb(0 0 0 / 3%);\n}\n\nbody.light_theme .df-fee-stat strong {\n  color: #1e2329;\n}\n\n/* \nbody.light_theme .df-va-row--iban {\n  background: rgba(209, 170, 103, 0.08);\n  border-color: rgba(209, 170, 103, 0.25);\n} */\n\nbody.light_theme .df-fee-notice {\n  color: #707a8a;\n  background: rgba(209, 170, 103, 0.08);\n}\n\nbody.light_theme .df-va-iban-missing {\n  color: #8a6a2a;\n}\n\nbody.light_theme .df-kyc-modal {\n  background: #fff;\n  border-color: #e1e1e1;\n}\n\nbody.light_theme .df-kyc-modal-title {\n  color: #101828;\n}\n\nbody.light_theme .df-kyc-modal-text {\n  color: #6a7282;\n}\n\nbody.light_theme .df-kyc-modal-close {\n  color: #111827;\n}\n\nbody.light_theme .df-kyc-modal-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n}\n\nbody.light_theme .df-faq-question {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-faq-answer {\n  color: #666;\n}\n\nbody.light_theme .df-deposit-history-title {\n  color: #101828;\n}\n\nbody.light_theme .df-dd-label {\n  color: #707a8a;\n}\n\nbody.light_theme .df-dd-trigger {\n  background: #f3f3f3;\n  border-color: #eaeaea;\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-dd-menu {\n  background: #fff;\n  border-color: #eaeaea;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);\n}\n\nbody.light_theme .df-dd-option {\n  color: #1a1a1a;\n}\n\nbody.light_theme .df-dd-option:hover,\nbody.light_theme .df-dd-option.is-selected {\n  background: rgba(209, 170, 103, 0.18);\n  color: #b89353;\n}\n\nbody.light_theme .df-deposit-history-empty-img {\n  filter: invert(0);\n}\n\nbody.light_theme .df-deposit-history-reason,\nbody.light_theme .df-deposit-history-empty-copy {\n  color: #667085;\n}\n\nbody.light_theme .df-fiat-deposit-detail-list dt {\n  color: #667085;\n}\n\nbody.light_theme .df-fiat-deposit-detail-list dd {\n  color: #101828;\n}\n\nbody.light_theme .df-deposit-history-row {\n  border-top-color: #eaecf0;\n  color: #101828;\n}\n\nbody.light_theme .df-deposit-history-copy-btn {\n  background: #f8fafc;\n  border-color: rgba(148, 163, 184, 0.45);\n  color: #334155;\n}\n\nbody.light_theme .df-deposit-history-copy-btn:hover {\n  background: #eef2ff;\n  border-color: rgba(99, 102, 241, 0.55);\n  color: #3730a3;\n}\n\nbody.light_theme .df-deposit-history-action-badge.is-success {\n  background: #ecfdf3;\n  border-color: #a7f3d0;\n}\n\nbody.light_theme .df-deposit-history-action-badge.is-pending {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n}\n\nbody.light_theme .df-deposit-history-action-badge.is-neutral {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #334155;\n}\n\nbody.light_theme .df-deposit-history-mobile-card {\n  border-top-color: #eaecf0;\n}\n\nbody.light_theme .df-deposit-history-mobile-date,\nbody.light_theme .df-deposit-history-mobile-value {\n  color: #101828;\n}\n\n/* ========================================= */\n/*     PAGE GLASS SKELETON (same layout)     */\n/* ========================================= */\n@keyframes df-sk-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.df-sk-glass {\n  display: block;\n  border-radius: 999px;\n  background: linear-gradient(90deg,\n      rgba(209, 170, 103, 0.1) 0%,\n      rgba(255, 255, 255, 0.22) 48%,\n      rgba(209, 170, 103, 0.1) 100%);\n  background-size: 220% 100%;\n  animation: df-sk-shimmer 1.4s ease-in-out infinite;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.df-sk-glass-panel {\n  background: linear-gradient(90deg,\n      rgba(209, 170, 103, 0.06) 0%,\n      rgba(255, 255, 255, 0.08) 50%,\n      rgba(209, 170, 103, 0.06) 100%);\n  background-size: 220% 100%;\n  animation: df-sk-shimmer 1.4s ease-in-out infinite;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.df-sk-glass--tag {\n  width: 140px;\n  height: 16px;\n  margin-bottom: 16px;\n}\n\n.df-sk-glass--h1 {\n  width: 86%;\n  height: 42px;\n  margin-bottom: 10px;\n  border-radius: 12px;\n}\n\nbody.light_theme .df-feature-text p {\n  color: #585C63;\n}\n\nbody.light_theme .dividerbdr {\n  background: linear-gradient(356deg, rgb(242 242 242) 0%, rgb(129 129 129) 50%, rgb(242 242 242) 100%);\n}\n\nbody.light_theme .df-how-steps li::before {\n  background: linear-gradient(180deg, rgba(209, 170, 103, 1) 0%, rgb(0 0 0 / 20%) 100%);\n}\n\n.df-sk-glass--h1s {\n  width: 62%;\n  height: 42px;\n  margin-bottom: 22px;\n  border-radius: 12px;\n}\n\n.df-sk-glass--lead {\n  width: 92%;\n  height: 16px;\n  margin-bottom: 36px;\n}\n\n.df-sk-glass--icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 1px solid rgba(209, 170, 103, 0.45);\n}\n\n.df-sk-glass--feat-title {\n  width: 180px;\n  height: 14px;\n  margin-bottom: 8px;\n}\n\n.df-sk-glass--feat-p {\n  width: 260px;\n  height: 12px;\n}\n\n.df-sk-glass--widget-title {\n  width: 140px;\n  height: 18px;\n}\n\n.df-sk-glass--pill {\n  width: 120px;\n  height: 28px;\n}\n\n.df-sk-glass--limit-label {\n  width: 110px;\n  height: 11px;\n  margin-bottom: 8px;\n}\n\n.df-sk-glass--label {\n  width: 72px;\n  height: 11px;\n  margin-bottom: 8px;\n}\n\n.df-sk-glass--line {\n  width: 100%;\n  height: 12px;\n  margin-top: 10px;\n}\n\n.df-sk-glass--circle {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.df-sk-glass--submit {\n  width: 100%;\n  height: 52px;\n  border-radius: 30px;\n  margin-top: 8px;\n}\n\n.df-sk-glass--section-title {\n  width: 320px;\n  height: 28px;\n  margin: 0 auto 28px;\n}\n\n.df-sk-glass--why-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  margin: 0 auto 16px;\n}\n\n.df-sk-glass--hist-title {\n  width: 200px;\n  height: 22px;\n}\n\n.df-sk-w60 {\n  width: 60%;\n}\n\n.df-sk-w70 {\n  width: 70%;\n}\n\n.df-sk-w80 {\n  width: 80%;\n}\n\n.df-sk-w90 {\n  width: 90%;\n}\n\n.df-sk-widget .df-limit-list {\n  min-height: 86px;\n}\n\n.df-sk-glass-panel--input {\n  min-height: 58px;\n  border-radius: 12px;\n}\n\n.df-sk-widget .df-payment-method {\n  min-height: 118px;\n  align-items: center;\n}\n\n.df-sk-why-card {\n  min-height: 160px;\n}\n\n.df-sk-table-wrap {\n  padding-top: 8px;\n}\n\n.df-sk-table-head {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr 1fr 0.8fr;\n  gap: 16px;\n  padding: 0 4px 14px;\n  font-size: 13px;\n  color: #84888c;\n}\n\n.df-sk-row {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr 1fr 0.8fr;\n  gap: 16px;\n  align-items: center;\n  padding: 16px 4px;\n  border-top: 1px solid #2b3139;\n}\n\n.df-sk-coin {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.df-sk-coin-txt {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.df-sk-bone {\n  display: block;\n  border-radius: 999px;\n}\n\n.df-sk-bone--xs {\n  width: 72px;\n  height: 10px;\n}\n\n.df-sk-bone--xxs {\n  width: 48px;\n  height: 8px;\n}\n\n.df-sk-bone--cell {\n  width: 88px;\n  height: 12px;\n  margin-left: auto;\n}\n\n.df-sk-bone--w50 {\n  width: 50%;\n}\n\n.df-sk-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.df-limit-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  /* padding: 14px 16px; */\n  margin-bottom: 20px;\n}\n\n.df-limit-list__title {\n  font-size: 21px;\n  /* text-transform: uppercase; */\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.df-limit-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  color: #9CA3AF;\n}\n\n.df-limit-row strong {\n  color: #fff;\n  font-weight: 500;\n  text-align: right;\n}\n\n.df-limit-row--sub strong {\n  font-weight: 500;\n  /* color: #d1aa67; */\n}\n\nbody.light_theme .df-sk-glass {\n  background: linear-gradient(90deg,\n      rgba(209, 170, 103, 0.1) 0%,\n      rgba(255, 255, 255, 0.85) 48%,\n      rgba(209, 170, 103, 0.1) 100%);\n  background-size: 220% 100%;\n}\n\nbody.light_theme .df-sk-glass-panel,\nbody.light_theme .df-sk-widget .df-limit-list {\n  background: linear-gradient(90deg,\n      rgba(209, 170, 103, 0.08) 0%,\n      rgba(255, 248, 236, 0.9) 50%,\n      rgba(209, 170, 103, 0.08) 100%);\n  background-size: 220% 100%;\n}\n\nbody.light_theme .df-sk-row {\n  border-color: #eaecef;\n}\n\n/* \nbody.light_theme .df-limit-list {\n  background: rgba(209, 170, 103, 0.08);\n  border-color: rgba(209, 170, 103, 0.22);\n} */\n\nbody.light_theme .df-limit-row strong {\n  color: #1e2329;\n}\n\nbody.light_theme .df-sk-bone,\nbody.light_theme .df-sk-circle {\n  background: linear-gradient(90deg,\n      rgba(209, 170, 103, 0.1) 0%,\n      rgba(255, 255, 255, 0.85) 48%,\n      rgba(209, 170, 103, 0.1) 100%);\n  background-size: 220% 100%;\n  animation: df-sk-shimmer 1.4s ease-in-out infinite;\n}\n\nbody.light_theme .df-limit-list__title {\n  color: #1e2329;\n}\n\nbody.light_theme .df-limit-row {\n  color: #585C63;\n}\n\n\n@media screen and (max-width:580px) {\n\n\n  .df-hero-widget {\n    padding: 15px;\n  }\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
